import {
  API_ENDPOINT_GOOGLE_EXCHANGE_TOKENS,
  API_ENDPOINT_GOOGLE_SEND_EMAIL,
  API_ENDPOINT_GOOGLE_SEND_INVITE_EMAIL,
  API_ENDPOINT_GOOGLE_SEND_RECEIPT_EMAIL,
} from "src/helpers/endpoint-urls";
import apiClient from "../helpers/api-client";
import { ETransactionType } from "../helpers/constants";

export const exchangeTokens = async (code: string) => {
  try {
    return await apiClient.post(API_ENDPOINT_GOOGLE_EXCHANGE_TOKENS, {
      code: code,
    });
  } catch (_e) {
    throw _e;
  }
};

export const getStatus = async () => {
  return await apiClient.get(`/integrations/gmail/status`);
};

export const sendEmail = async ({
  to,
  subject,
  text,
  html,
}: {
  to: string;
  subject: string;
  text: string;
  html: string;
}) => {
  try {
    return await apiClient.post(API_ENDPOINT_GOOGLE_SEND_EMAIL, {
      to,
      subject,
      text,
      html,
    });
  } catch (_e) {
    throw _e;
  }
};

interface IReceiptFieldsToSend {
  invoice: string;
  payTo: string;
  type: string;
  total: string;
  time: string;
  date: string;
  paymentVoucher: string;
  settings: {
    language: string;
    type: ETransactionType;
  };
  attachments: any[];
  description: string;
  paymentMethod: string;
}

export const sendReceipt = async ({
  invoice,
  payTo,
  type,
  total,
  time,
  date,
  paymentVoucher,
  settings,
  attachments,
  description,
  paymentMethod,
}: IReceiptFieldsToSend) => {
  try {
    return await apiClient.post(API_ENDPOINT_GOOGLE_SEND_RECEIPT_EMAIL, {
      invoice,
      payTo,
      type,
      total,
      time,
      date,
      paymentVoucher,
      settings,
      attachments,
      description,
      paymentMethod,
    });
  } catch (_e) {
    throw _e;
  }
};

export const sendInvite = async ({
  email,
  name,
}: {
  email: string;
  name: string;
}) => {
  try {
    return await apiClient.post(API_ENDPOINT_GOOGLE_SEND_INVITE_EMAIL, {
      email,
      name,
    });
  } catch (_e) {
    throw _e;
  }
};

export const isRevoked = async () => {
  return await apiClient.post(`/integrations/gmail/revoke`);
};
